import {ActivatedRouteSnapshot, BaseRouteReuseStrategy, DetachedRouteHandle} from "@angular/router";
import {Injectable} from "@angular/core";

export class AppRouteReuseStrategy extends BaseRouteReuseStrategy {

  private _overrideShouldReuseRoute: boolean | undefined = undefined;

  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (this._overrideShouldReuseRoute !== undefined) {
      return this._overrideShouldReuseRoute;
    }
    if (future.data["reuseComponent"] === undefined) {
      return (future.routeConfig === curr.routeConfig);
    }
    return future.data["reuseComponent"];
  }


  public set overrideShouldReuseRoute(value: boolean | undefined) {
    this._overrideShouldReuseRoute = value;
  }

}
